import useNavigationStore from "@src/stores/navigationStore";
import Finish from "./Finish";
import UploadMissingDocs from "./UploadMissingDocs";

const componentMap = {
    UploadMissingDocs: UploadMissingDocs,
    Finish: Finish,
};

export default function SeventhSection() {
    const { section } = useNavigationStore();

    const SelectedComponent = componentMap[section.block as keyof typeof componentMap] || null;

    return <>{SelectedComponent ? <SelectedComponent /> : null}</>;
}
